<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?$t('app_sub_org'):$t('upd_app_sub_org')}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="$t('logo_img')" prop="img_lnk">
                <myCropImg :my_disable="formData.rw_status != 'N'" :autoCropWidthHeight="[400,400]" :original_url="formData.img_lnk" crop_height="450px" crop_width="450px" @cropImgUpload="setOrgIcon"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('build_img')" prop="build_img_lnk">
                <myCropImg :my_disable="formData.rw_status != 'N'" :autoCropWidthHeight="[600,360]" crop_height="500px" crop_width="700px" :original_url="formData.build_img_lnk" @cropImgUpload="setOrgBuildImg"></myCropImg>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('org_mod_cname')" prop="mod_id">
                        <el-select class="fillw" v-model="formData.mod_id" :placeholder="$t('select')" @change="modChange">
                            <el-option :label="item.mod_cname"  :value="item.mod_id" v-for="item in mods" :key="item.mod_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('fee')" prop="fee_cat_id">
                        <el-select class="fillw" v-model="formData.fee_cat_id" :placeholder="$t('select')">
                            <el-option :label="item.cat_cdesc"  :value="item.cat_id" v-for="item in fee" :key="item.cat_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('join_type_cname')" prop="join_type">
                        <el-select class="fillw" v-model="formData.join_type" :placeholder="$t('select')">
                            <el-option :label="item.type_cname"  :value="item.join_type" v-for="item in join_type" :key="item.join_type"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item v-if="['M3'].includes(formData.mod_cat)" :label="$t('mod2_org')" prop="mod2_org_id">
                <el-radio-group v-model="formData.mod2_org_id" v-if="mod2_org.length > 0" @change="onMod2OrgChange">
                    <el-radio :label="item.org_id" :value="item.org_id" v-for="item in mod2_org" :key="item.org_id">{{item.org_cname}}</el-radio>
                </el-radio-group>
                <div v-else>{{$t('wait_not')}}</div>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('code')" prop="org_code">
                        <el-input v-model="formData.org_code" :placeholder="$t('input')">
                            <span slot="prepend" v-if="['M3'].includes(formData.mod_cat) && mod2_org_code != ''">{{mod2_org_code}}-</span>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item :label="$t('cname')" prop="org_cname">
                        <el-input v-model="formData.org_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('link_cname')" prop="link_cname">
                        <el-input v-model="formData.link_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('link_mobile')" prop="link_mobile">
                        <el-input v-model="formData.link_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_cname')" prop="cu_cname">
                        <el-input v-model="formData.cu_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_mobile')" prop="cu_mobile">
                        <el-input v-model="formData.cu_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_time_area')" prop="cu_time_area">
                        <el-input v-model="formData.cu_time_area" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="['M3'].includes(formData.mod_cat)">
                <el-col :span="8">
                    <el-form-item label="信誉消费模式" prop="cr_cat">
                        <el-select class="fillw" v-model="formData.cr_cat" :placeholder="$t('select')">
                            <el-option :label="item.value"  :value="item.key" v-for="item in cr_cat" :key="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="信誉额度" prop="cr_qty">
                        <el-input v-model="formData.cr_qty" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="每日低于" prop="day_cr_qty_min">
                        <el-input v-model="formData.day_cr_qty_min">
                            <span slot="append">自动恢复<span class="f-blue">(填空不恢复)</span></span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--省市区选择-->
            <el-form-item :label="$t('addr2')" prop="addrLabel">
                <el-cascader class="fillw" :options="addrData" trigger="click" :filterable="true" v-model="formData.addrLabel"
                             ref="ref_addr" @change="addrValueChang" :props="{value:'label'}"></el-cascader>
            </el-form-item>
            <!--详细地址-->
            <el-form-item :label="$t('addr')" prop="addr">
                <el-input v-model="formData.addr" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-row v-if="false">
                <el-col :span="12">
                    <el-form-item :label="$t('org_admin_code')" prop="org_admin_code">
                        <el-input v-model="formData.org_admin_code" :placeholder="$t('user_code')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit" v-if="formData.rw_status == 'N'">{{$t('save')}}</el-button>
                <el-button :disabled="true" v-else>{{formData.rw_status_cdesc}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    import addr from '../../../utils/addr/index'
    import mod from "../../system/mod";
    export default {
        components:{
            myCropImg
        },
        data:function(){
            return{
                op: this.$base.getRequest().op,
                relist:false,
                formData: {
                    app_id:'',
                    img_lnk: "",
                    build_img_lnk: "",
                    org_code: "",
                    org_cname: "",
                    mod_cat: '',
                    mod_id: "",
                    fee_cat_id:'',
                    join_type:'',
                    cr_cat:'',
                    cr_qty:'',
                    day_cr_qty_min:'',
                    link_cname: "",
                    link_mobile: "",
                    cu_cname: "",
                    cu_mobile: "",
                    cu_time_area: "",
                    prov: "",
                    city: "",
                    area: "",
                    addrLabel:[],
                    addr: "",
                    lng:'0', // 经度
                    lat:'0',  // 维度
                    org_admin_code: "administrator",
                    rw_status:'N',
                    rw_status_cdesc:'',
                    mod2_org_id:''
                },
                rule: {
                    img_lnk: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    org_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    mod_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    fee_cat_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    join_type: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    link_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addrLabel: [{required: true, message: this.$t('select'), trigger: 'change', type:'array'}],
                    addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    mod2_org_id: [{required: false, message: this.$t('select'), trigger: 'change'}],
                    cr_cat: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    cr_qty: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },
                addrData: [],
                mods:[],
                join_type: [],
                cr_cat: [],
                fee: [],
                mod2_org: [],
                mod2_org_code:'' //用于新增是补充编码
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            if(this.op == 'add'){
                this.getLoad();
            }
            else{
                this.formData.app_id = this.$base.getRequest().id;
                this.getInfo();
            }
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500);
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setOrgBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            setOrgIcon: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            addrValueChang(value){
                this.formData.prov = value[0];
                this.formData.city = value[1];
                this.formData.area = value[2];
            },
            onMod2OrgChange:function (){
                var select_mod2_org = this.mod2_org.filter(item => item.org_id == this.formData.mod2_org_id)[0];
                if(this.op == 'add'){
                    this.mod2_org_code = select_mod2_org.org_code;
                }
            },
            getLoad: function(){
                var data = {
                };
                this.$base.showLoading();
                this.$request.sendPost("org-app/before-add",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = data.mods;
                        this.join_type = data.join_type;
                        this.cr_cat = data.cr_cat;
                        this.mod2_org = data.mod2_org;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var data = {
                    app_id: this.formData.app_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-app/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = data.mods;
                        this.join_type = data.join_type;
                        this.cr_cat = data.cr_cat;
                        this.fee = data.fee;
                        this.mod2_org = data.mod2_org;
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.formData.addrLabel=[this.formData.prov,this.formData.city,this.formData.area];
                        if(data.info.mod_cat == 'M3'){
                            this.onMod2OrgChange();
                        }
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            modChange: function(mod_id){
                var mod = this.mods.filter(item=>item.mod_id == mod_id)[0];
                this.formData.mod_cat = mod.mod_cat;
                if(['M3'].includes(mod.mod_cat)){
                    this.rule.mod2_org_id[0].required = true;
                }
                else{
                    this.rule.mod2_org_id[0].required = false;
                }

                var data = {
                    mod_id
                };
                this.fee = [];
                this.fee_cat_id = '';
                this.$base.showLoading();
                this.$request.sendPost("org-app/mod-change",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        if(data.fee.length > 0){
                            this.formData.fee_cat_id = data.fee[0].cat_id;
                        }
                        this.fee = data.fee;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op == 'add'?'org-app/add':'org-app/upd';
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/app/save.vue